import React, { Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import AccountBenefits from "./views/app/accounts/accountbenefits";
import Accounts from "./views/app/accounts/accounts";
import AddressScreen from "./views/app/accounts/address";
import MembersList from "./views/app/administration/membersList";
import Header from "./views/app/Nav/header";
import SideNav from "./views/app/Nav/sideNav";
import AddReqScreen from "./views/app/requests/jobrequisition/addRequest";
import ReqSkills from "./views/app/requests/jobrequisition/skills/reqskills";
import Requests from "./views/app/requests/requests";
import AddNotes from "./views/app/requests/jobrequisition/addnotes";
import LocationContact from "./views/app/accounts/locationcontacts";
import Contact from "./views/app/accounts/accountcontacts";
import AuthVerify from "./utilities/authverifyutitlity";
import Notifications from "./views/app/notifications/notifications";
import SearchCandidate from "./views/app/searchcandidates/searchcandidates";
import JobBoard from "./views/app/jobboard/jobboard";
import JobBoardContacts from "./views/app/jobboard/jobboardcontacts";
import InviteViaEmail from "./views/app/searchcandidates/inviteviaemail";
import SearchThankYou from "./views/app/searchcandidates/searchthankyou";
import InviteViaText from "./views/app/searchcandidates/inviteviatext";
import BasicInformation from "./views/app/requests/jobrequisition/basicInformationScreen";
import FileUpload from "./views/app/requests/jobrequisition/fileUpload";
import ViewCandidate from "./views/app/requests/jobrequisition/candidatesview/viewcandidate";
import ViewCandidateDetails from "./views/app/requests/jobrequisition/candidatesview/viewcandidatedetails";

const AppRoutes = () => {
  return (
    <>
      <Header />
      <SideNav />

      <div className="bodyContent grid min-sm:grid-cols-2 min-sm:absolute min-sm:ml-48 min-sm:top-24 wid_body">
        <div className="myjobs_container min-sm:col-span-2 max-sm:-mt-[120px] ">
          <Suspense fallback="loading...">
            <Switch>
              <Route exact path="/requests" component={Requests} />
              <Route path="/addrequest/:id" component={AddReqScreen} />
              <Route path="/basicinfo" component={BasicInformation} />
              <Route path="/location/:id/:name/:accounId/:accountName" component={LocationContact} />
              <Route path="/contact/:id/:name" component={Contact} />
              <Route path="/fileupload" component={FileUpload} />
              <Route path="/skills" component={ReqSkills} />
              <Route path="/addnotes" component={AddNotes} />
              <Route path="/accounts" component={Accounts} />
              <Route path="/teammembers" component={MembersList} />
              <Route path="/address/:id/:name" component={AddressScreen} />
              <Route path="/notifications" component={Notifications} />
              <Route path="/viewcandidate" component={ViewCandidate} />
              
              <Route path="/searchcandidates" component={SearchCandidate} />
              <Route path="/inviteviaemail" component={InviteViaEmail} />
              
              <Route path="/inviteviatext" component={InviteViaText} />

              <Route path="/searchthankyou" component={SearchThankYou} />

              <Route path="/jobboard" component={JobBoard}/>
              <Route path="/jobboardcontacts" component={JobBoardContacts}/>
              <Route
                 path="/viewcandidatedetails/:jobreqid/:applicationid"
                component={ViewCandidateDetails}
              />
              <Route path="/accountbenefits/:id" component={AccountBenefits} />
              <Redirect to="/requests" />
            </Switch>
          </Suspense>
          <AuthVerify></AuthVerify>
        </div>
      </div>
    </>
  );
};

export default AppRoutes;